import { RouterProvider } from 'react-router-dom'
import { AppBridgeProvider } from './providers/AppBridgeProvider'
import { router } from './router'

export function App() {
  return (
    <AppBridgeProvider>
      <RouterProvider router={router} />
    </AppBridgeProvider>
  )
}
